import { render, staticRenderFns } from "./overduelist.vue?vue&type=template&id=647e4c80&scoped=true&"
import script from "./overduelist.vue?vue&type=script&lang=js&"
export * from "./overduelist.vue?vue&type=script&lang=js&"
import style0 from "./overduelist.vue?vue&type=style&index=0&id=647e4c80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647e4c80",
  null
  
)

export default component.exports